/**
 * Synapsy Widget - Bubble (Balão de Mensagem)
 * Cria o balão "Como posso ajudar?" ancorado acima do launcher.
 * Visível apenas com o chat fechado; clicar abre o chat (wiring em index.js).
 */

import { getBubbleStyles, getBubbleCloseStyles } from "./styles.js";
import { onActivate } from "./a11y.js";

const BUBBLE_TEXT = "Olá! Precisa de ajuda?";

/**
 * Cria o balão de mensagem
 * @param {Object} config - Configuração do widget
 * @returns {HTMLElement} Elemento do balão
 */
export function createBubble(config) {
  const bubble = document.createElement("div");
  bubble.id = "synapsy-bubble";
  bubble.className = "synapsy-bubble";
  bubble.style.cssText = getBubbleStyles(config.position);
  bubble.style.display = "none";
  bubble.setAttribute("role", "button");
  bubble.setAttribute("tabindex", "0");
  bubble.setAttribute("aria-label", BUBBLE_TEXT);

  const text = document.createElement("span");
  text.textContent = BUBBLE_TEXT;
  bubble.appendChild(text);

  const tail = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  tail.setAttribute("width", "10");
  tail.setAttribute("height", "14");
  tail.setAttribute("viewBox", "0 0 10 14");
  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  if (config.position === "left") {
    path.setAttribute("d", "M10,0 C10,5 6,10 0,14 L10,14 Z");
    tail.style.cssText = "position:absolute;bottom:0;left:-9px;display:block;";
  } else {
    path.setAttribute("d", "M0,0 C0,5 4,10 10,14 L0,14 Z");
    tail.style.cssText = "position:absolute;bottom:0;right:-9px;display:block;";
  }
  path.setAttribute("fill", "#fff");
  tail.appendChild(path);
  bubble.appendChild(tail);

  // X opcional de dispensar (default: renderiza). Clicar no X oculta o balão e
  // marca dataset.dismissed nele mesmo — o balão é dono do próprio estado de
  // dispensa, sem abrir o chat. showClosedUI (index.js) respeita essa flag.
  if (config.bubbleClosable) {
    const close = document.createElement("span");
    close.className = "synapsy-bubble-close";
    close.textContent = "×";
    close.setAttribute("role", "button");
    close.setAttribute("aria-label", "Fechar mensagem");
    close.style.cssText = getBubbleCloseStyles();
    // Dispensa por clique OU teclado. stopPropagation impede que o mesmo
    // evento acione o "abrir chat" do balão (pai).
    onActivate(close, (event) => {
      event.stopPropagation();
      bubble.dataset.dismissed = "true";
      bubble.style.display = "none";
    });
    bubble.appendChild(close);
  }

  return bubble;
}
